export const state = {
    connectionId: null,
    dashboard: {
        statistics: {}
    },
    incident: {
        statistics: {},
        incidents: [],
        activeIncidents: [],
        activeAccidents: []
    }
}

export const getters = {
    connectionId: state => state.connectionId,
    dashboard: state => state.dashboard,
    incident: state => state.incident,
}

export const mutations = {
    SOCKET_CONNECTION_ID (state, id) {
        state.connectionId = id;
    },
    SOCKET_DASHBOARD_STATISTICS (state, data) {
        state.dashboard.statistics = data;
    },
    SOCKET_INCIDENT_STATISTICS (state, data) {
        state.incident.statistics = data;
    },
    SOCKET_INCIDENT_DATA (state, data) {
        state.incident.incidents = data;
    },
    SOCKET_RPO_ACTIVE_ASSIGNED_INCIDENTS (state, data) {
        state.incident.activeIncidents = data;
    },
    SOCKET_RPO_ACTIVE_ASSIGNED_ACCIDENTS (state, data) {
        state.incident.activeAccidents = data;
    },
};

export const actions = {
    async SOCKET_CONNECTION_ID ({ commit }, id) {
        commit('SOCKET_CONNECTION_ID', id);
    },
    async SOCKET_DASHBOARD_STATISTICS ({ commit }, data) {
        commit('SOCKET_DASHBOARD_STATISTICS', data);
    },
    async SOCKET_INCIDENT_STATISTICS ({ commit }, data) {
        commit('SOCKET_INCIDENT_STATISTICS', data);
    },
    async SOCKET_INCIDENT_DATA ({ commit }, data) {
        commit('SOCKET_INCIDENT_DATA', data);
    },
    async SOCKET_RPO_ACTIVE_ASSIGNED_INCIDENTS ({ commit }, data) {
        commit('SOCKET_RPO_ACTIVE_ASSIGNED_INCIDENTS', data);
    },
    async SOCKET_RPO_ACTIVE_ASSIGNED_ACCIDENTS ({ commit }, data) {
        commit('SOCKET_RPO_ACTIVE_ASSIGNED_ACCIDENTS', data);
    },
};



